// The recovery codes (27-admin.md, "The codes"): a list named "Recovery codes" in two columns and
// Copy with the address they belong to ("Save as file" was a candidate to drop). Shared by the
// set-up page and My account.
import { CopyButton } from '../blocks/Button';
import { t } from '../i18n';

export function Codes({ codes, address }: { codes: string[]; address: string }) {
  return (
    <>
      <ul className="recovery-codes" aria-label={t('recovery.codes')}>
        {codes.map((c) => (
          <li key={c}>{c}</li>
        ))}
      </ul>
      <CopyButton small text={`${t('recovery.codesFor', { address })}\n\n${codes.join('\n')}`} />
    </>
  );
}
